import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-workreport-dialog',
  templateUrl: './edit-workreport-dialog.component.html',
  styleUrls: ['./edit-workreport-dialog.component.css']
})
export class EditWorkreportDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
